import React, { ComponentProps } from "react";
import { appConfig } from "src/config";
import { getLanguage } from "src/utils/meristemContext";
import { Text, TranslationProps } from "../core/Text";

const baseDisclaimerLinks = {
  TocLink: `${appConfig.BLOG_DOMAIN}/terms-and-conditions-of-use/`,
  PrivacyLink: `${appConfig.BLOG_DOMAIN}/noom-privacy-policy/`,
  ResearchLink: `${appConfig.BLOG_DOMAIN}/research-policy/`,
  GooglePrivacyLink: "https://policies.google.com/privacy",
  HIPAALink: `${appConfig.BLOG_DOMAIN}/hipaa-notice/`,
  GoogleTocLink: "https://policies.google.com/terms",
  SupportLink: `${appConfig.BLOG_DOMAIN}/support/contact-support`,
  EmailHMSupportLink: "mailto:hmsupport@noom.com",
  EmailSupportLink: "mailto:programsupport@noom.com",
  FsaHsaLink: "https://www.irs.gov/publications/p969",
  DoiJcem3943: "https://doi.org/10.1210/jcem.82.5.3943",
  DoiBeem2013: "https://doi.org/10.1016/j.beem.2013.05.003",
  DoiIje2013: "https://doi.org/10.1155/2013/942030",
  DoiAjcn941: "https://doi.org/10.1093/ajcn/82.5.941",
  EndotextLink: "https://www.ncbi.nlm.nih.gov/books/NBK279163/",
  DoiRco29: "https://doi.org/10.1002/rco2.9",
  DoiAmjmed: "https://doi.org/10.1016/j.amjmed.2014.02.007",
  DoiGeroScience: "https://doi.org/10.1007/s11357-022-00705-1",
  DoiEurJN: "https://doi.org/10.1007/s00394-019-01919-4",
  DoiCellMetab: "https://doi.org/10.1016/j.cmet.2018.02.011",
  DoiScience: "https://doi.org/10.1126/science.aac4854",
  DoiPnas: "https://doi.org/10.1073/pnas.1417921112",
  DoiMetabHealthDis: "https://doi.org/10.1038/s44324-025-00067-0",
  DoiNatureMed0675: "https://doi.org/10.1038/s41591-019-0675-0",
  DoiClinJPain: "https://doi.org/10.1097/AJP.0000000000000166",
  DoiPsyneuen: "https://doi.org/10.1016/j.psyneuen.2012.07.013",
  DoiPsychosomMed: "https://doi.org/10.1097/PSY.0000000000001091",
};
const localeSpecificDisclaimerLinks = {
  es: {
    TocLink: "https://www.noom.com/terms-and-conditions-of-use/spanish/",
    PrivacyLink: "https://www.noom.com/privacy-policy-spanish/",
    ResearchLink: "https://www.noom.com/es/research-policy/",
    SupportLink: "https://www.noom.com/es/support/contact-support/",
    EmailSupportLink: "mailto:programsupport-es@noom.com",
  },
  de: {
    TocLink: "https://web2.noom.com/de/de-tos/",
    PrivacyLink: "https://web2.noom.com/de/de-privacy-policy/",
    ResearchLink: "https://web2.noom.com/de/research-policy-german/",
    SupportLink:
      "https://web2.noom.com/de/support/kundenservice-premium-funktionen/kontaktiere-support/",
    EmailSupportLink: "mailto:support-de@noom.com",
  },
};

export function getDisclaimerUrls() {
  // Merge locale-specific links with default links
  return {
    ...baseDisclaimerLinks,
    ...localeSpecificDisclaimerLinks[getLanguage() as "de" | "es"],
  };
}

export function DisclaimerLinks(props: ComponentProps<typeof Text>) {
  const disclaimerUrls = getDisclaimerUrls();

  // Generate a map of DisclaimerLinks for convenient interpolation of disclaimer links in a <Text /> component.
  const disclaimerLinks: TranslationProps["components"] = Object.entries(
    disclaimerUrls
  ).reduce((map, [linkName, href]) => {
    // eslint-disable-next-line no-param-reassign
    map[linkName] = <DisclaimerLink href={href} />;
    return map;
  }, {});

  return <Text components={disclaimerLinks} {...props} />;
}

export function DisclaimerLink({
  href,
  children,
}: {
  href: string;
  children?: React.ReactNode;
}) {
  return (
    <a href={href} css={{ color: "inherit" }} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
}
